import { render, staticRenderFns } from "./capNhatBaiViet.vue?vue&type=template&id=e13f333a&"
import script from "./capNhatBaiViet.vue?vue&type=script&lang=js&"
export * from "./capNhatBaiViet.vue?vue&type=script&lang=js&"
import style0 from "./capNhatBaiViet.vue?vue&type=style&index=0&id=e13f333a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports